import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import EpimsLogoOnly from "./components/EpimsLogoOnly";

const MainWrapper = styled.div`
  width: 100%;
  padding: 10px;
`
const MeasuresList = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  row-gap: 10px;
  column-gap: 10px;
  max-width: 1500px;
  flex-wrap: wrap;
  margin-inline: auto;
`

const MeasuresListItem = styled.div`
  border: 2px solid #303030;
  border-radius: 16px;
  width: 480px;
  overflow: hidden;
  transition: scale 0.2s ease;
  &:hover {
    scale: 1.02;
  }
`

function ContractorMeasureListingPage() {

    const routeParams = useParams()
    const [loaded, setLoaded] = useState(false)
    const [measures, setMeasures] = useState([])
    const [shortTitle, setShortTitle] = useState('')

    const navigate = useNavigate()

    useEffect(() => {
        const url = process.env.REACT_APP_API_END_POINT + 'contractorsmeasures';
        fetch(url, {
          headers: {
            'Accept': 'application/json',
          },
          method: "POST",
          credentials: "include",
          body: JSON.stringify({
            "report_path": routeParams.id + '/' + routeParams.slug,
          })
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['success'] === true) {
            setLoaded(true)
            setMeasures(data['measures'])
            setShortTitle(data['short_title'])
          }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const gotoMeasure = (code) => {
      navigate('/s/' + routeParams.id + '/' + routeParams.slug + '/c/' + code)
    }

    if (!loaded) return <div><FontAwesomeIcon className="spinner-slow" icon={solid("spinner")} style={{color: "#000000", height: "100px", width: "100px" }} /></div>

    return (
      <>
        <MainWrapper>
          <p style={{textAlign: "center"}}><EpimsLogoOnly /></p>
          <h1 style={{textAlign: "center"}}>Recommended improvements for {shortTitle}</h1>
          <p style={{textAlign: "center"}}>We have recommended contractors for the following measues from your report, select a measure to continue.</p>
          <MeasuresList>
            {measures.map(
              measure => {
                return <MeasuresListItem onClick={() => gotoMeasure(measure.code)}>
                  <div style={{width: "100%", height: "300px", backgroundImage: "url('/improvement_images/" + measure.image + "')", backgroundSize: "cover", backgroundPosition: "center"}}></div>
                  <p style={{fontWeight: "bold", textAlign: "center", fontSize: "24px", marginTop: "8px"}}>{measure.name}</p>
                </MeasuresListItem>
              }
            )}
          </MeasuresList>
        </MainWrapper>
      </>
    )
}

export default ContractorMeasureListingPage;